/**
 * Aufmass status constants
 * These are used across the frontend application to maintain consistency with backend status values
 */

export const AUFMASS_STATUS = {
	DRAFT: "DRAFT",
	FINALIZED: "FINALIZED",
	ARCHIVED: "ARCHIVED",
};

// Helper function to check if the aufmass is in a specific status
export const isAufmassStatus = (aufmass, status) => {
	return aufmass?.status === status;
};

// Helper function to get status display translation key
export const getStatusTranslationKey = (status) => {
	return `aufmass.status.${status}`;
};

export default AUFMASS_STATUS;
